/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { useFieldArray, useForm, Controller } from "react-hook-form";
import {
  Flex,
  Heading,
  Button,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import { DateTimePicker, TimePicker } from "@progress/kendo-react-dateinputs";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import moment from "moment";
import { MdDeleteSweep } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { OPERATION_WINDOW_DEFAULT } from "../constants";
import { dateTimeFormat } from "../../../utils/constants";

export default function OperationalWindow({
  addData,
  onNextStep,
  onPrevStep,
  operationalWindows,
}) {
  const [currentEditing, setCurrentEditing] = useState(null);
  const {
    handleSubmit,
    setValue,
    watch,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ...OPERATION_WINDOW_DEFAULT,
      operationalWindows: [...operationalWindows],
    },
  });
  const generalFieldProps = { control, errors };
  const { fields: operationalWindowFields, remove: operationalWindowRemove } =
    useFieldArray({
      control: generalFieldProps.control,
      name: "operationalWindows",
    });

  useEffect(() => {
    if (addData) {
      addData([...operationalWindowFields]);
    }
  }, [watch("operationalWindows")]);
  const submitInfo = (data) => {
    const _windows = [...operationalWindowFields];
    const newWindow = {
      startDateTime: data.startDateTime,
      endDateTime: data.endDateTime,
      cutOffTime: data.cutOffTime,
    };
    if (currentEditing !== null) {
      _windows[currentEditing] = newWindow;
      setCurrentEditing(null);
    } else {
      _windows.push(newWindow);
    }
    reset({
      ...OPERATION_WINDOW_DEFAULT,
      operationalWindows: [..._windows],
    });
  };

  const editWindowCell = ({ dataItem, dataIndex }) => {
    return (
      <td>
        <Flex
          title="Edit Operational Window"
          cursor="pointer"
          onClick={() => {
            reset({
              ...OPERATION_WINDOW_DEFAULT,
              ...dataItem,
              operationalWindows: [...operationalWindowFields],
            });
            setCurrentEditing(dataIndex);
          }}
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const deleteWindowCell = ({ dataIndex }) => {
    return (
      <td>
        <Flex
          title="Delete Operational Window"
          cursor="pointer"
          onClick={() => {
            operationalWindowRemove(dataIndex);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </Flex>
      </td>
    );
  };
  const cancelEditing = () => {
    reset({
      ...OPERATION_WINDOW_DEFAULT,
      operationalWindows: [...operationalWindowFields],
    });
    setCurrentEditing(null);
  };
  return (
    <form onSubmit={handleSubmit(submitInfo)}>
      <Flex w="100%" justify="space-between" flexDirection="row">
        <Heading style={{ width: "100%" }}>Operational Window</Heading>
        <Flex w="100%" justify="flex-end" flexDirection="row">
          <Flex
            w="100%"
            justify="flex-end"
            flexDirection="row"
            gap="16px"
            onClick={() => {}}
          >
            <Button
              type="button"
              onClick={() => onPrevStep(operationalWindowFields)}
            >
              Back
            </Button>
            <Button
              type="button"
              onClick={() => onNextStep(operationalWindowFields)}
            >
              Next
            </Button>
          </Flex>
        </Flex>
      </Flex>

      <FormControl isRequired>
        <FormLabel>Start Date Time</FormLabel>
        <Controller
          control={generalFieldProps.control}
          name="startDateTime"
          render={({ field }) => {
            return (
              <DateTimePicker
                className={errors.startDateTime ? "error-field" : ""}
                value={field.value || null}
                onChange={(e) => {
                  field.onChange(e.value);
                  setValue("endDateTime", e.value);
                }}
              />
            );
          }}
        />

        {errors ? (
          errors.startDateTime ? (
            <p className="error-message">
              {errors.startDateTime.message || "Please Select Date!"}
            </p>
          ) : (
            <></>
          )
        ) : (
          <></>
        )}
      </FormControl>
      <FormControl isRequired>
        <FormLabel>End Date Time</FormLabel>
        <Controller
          control={generalFieldProps.control}
          name="endDateTime"
          render={({ field }) => {
            return (
              <DateTimePicker
                className={errors.endDateTime ? "error-field" : ""}
                value={field.value || null}
                min={watch("startDateTime")}
                onChange={(e) => {
                  field.onChange(e.value);
                }}
              />
            );
          }}
        />

        {errors ? (
          errors.endDateTime ? (
            <p className="error-message">
              {errors.endDateTime.message || "Please Select Date!"}
            </p>
          ) : (
            <></>
          )
        ) : (
          <></>
        )}
      </FormControl>

      <FormControl isRequired>
        <FormLabel>Cut Off Time</FormLabel>
        <Controller
          control={generalFieldProps.control}
          name="cutOffTime"
          render={({ field }) => {
            return (
              <TimePicker
                className={errors.cutOffTime ? "error-field" : ""}
                value={field.value || null}
                onChange={(e) => {
                  field.onChange(e.value);
                }}
              />
            );
          }}
        />

        {errors ? (
          errors.cutOffTime ? (
            <p className="error-message">
              {errors.cutOffTime.message || "Please Select Time!"}
            </p>
          ) : (
            <></>
          )
        ) : (
          <></>
        )}
      </FormControl>
      <Grid data={operationalWindowFields}>
        <GridColumn
          title="Start Date Time"
          cell={({ dataItem }) => (
            <td>{moment(dataItem.startDateTime).format(dateTimeFormat)}</td>
          )}
        />
        <GridColumn
          title="End Date Time"
          cell={({ dataItem }) => (
            <td>{moment(dataItem.endDateTime).format(dateTimeFormat)}</td>
          )}
        />
        <GridColumn
          title="Cut Off Time"
          cell={({ dataItem }) => (
            <td>{moment(dataItem.cutOffTime).format(dateTimeFormat)}</td>
          )}
        />
        <GridColumn title="Edit" cell={editWindowCell} width={120} />
        <GridColumn title="Delete" cell={deleteWindowCell} width={120} />
      </Grid>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "16px",
        }}
      >
        {currentEditing !== null ? (
          <Button onClick={cancelEditing}>Cancel</Button>
        ) : (
          <></>
        )}
        <Button type="submit">
          {currentEditing !== null
            ? "Update Operational Window"
            : "Add Operational Window"}
        </Button>
      </div>
    </form>
  );
}
